import { render, staticRenderFns } from "./SummaryPropertyReadings.vue?vue&type=template&id=0868fcc4"
import script from "./SummaryPropertyReadings.vue?vue&type=script&lang=js"
export * from "./SummaryPropertyReadings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports